import CmsPage from "./CmsPage";

const PrivacyPolicy = () => {
  return <CmsPage slug="privacy-policy" titleFallback="Privacy Policy" />;
};

export default PrivacyPolicy;
